import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  medicine_table : [],
  duration_measure:[],
  duration_total:[],
  frequency:[]
};
const medicineReducer = createSlice({
  name: "medicineReducer",
  initialState,
  reducers: {
 addMedicines(state,action){
state.medicine_table=[...state.medicine_table,action.pa]
   
    },
    addFrequency(state,action){
    
      state.frequency=action.payload
    },
    addDurationTotal(state,action){
      state.duration_total=action.payload
    },
    addDurationMeasure(state,action){
        state.duration_measure=action.payload
      },
    removeMedicines(state,action){
      state.medicine_table=[]
    }
  },
});
export const { addMedicines,addFrequency,addDurationTotal,addDurationMeasure,removeMedicines} = medicineReducer.actions;
export default medicineReducer.reducer;
